'use client';
import { useIntl } from '@capsicum/common';
import {
	BaseCountrySelectInput,
	type BaseCountrySelectInputProps,
	BaseTextInput,
	type BaseTextInputProps
} from '@capsicum/common-web';
import { type SmsLoginFormType } from '@capsicum/socios-core';
import { type FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { styled } from 'styled-components';

import type { Intersect } from '@capsicum/common';

export const Phone: FC<
	Intersect<BaseCountrySelectInputProps, BaseTextInputProps> & {
		className?: string;
		testID?: string;
	}
> = ({ className, testID, ...props }) => {
	const { $t } = useIntl();
	const form = useFormContext<SmsLoginFormType>();

	return (
		<S.Wrapper className={className}>
			<Controller
				control={form.control}
				name="country"
				render={({ field, fieldState: { error } }) => (
					<S.CountrySelect
						{...props}
						{...field}
						error={
							error
								? {
										message: '',
										type: error.type
									}
								: undefined
						}
						labelProp="internationalCallingCode"
						testID={`${testID}-country-select`}
						variant="countryWithCodeAndFlag"
					/>
				)}
			/>

			<Controller
				control={form.control}
				name="mobileNumber"
				render={({ field, fieldState: { error } }) => (
					<S.MobileNumber
						{...props}
						{...field}
						error={
							error
								? {
										message: '',
										type: error.type
									}
								: undefined
						}
						name="mobileNumber"
						pattern="[0-9]*"
						placeholder={$t('global.phoneNumber')}
						testID={`${testID}-mobile-number`}
						type="tel"
					/>
				)}
			/>
		</S.Wrapper>
	);
};

namespace S {
	export const Wrapper = styled.div`
		display: flex;
		width: 100%;
		gap: ${({ theme }) => theme.spacings.xxsmall};
	`;

	export const MobileNumber = styled(BaseTextInput)`
		flex-grow: 1;
	`;

	export const CountrySelect = styled(BaseCountrySelectInput)`
		width: 5em;
	`;
}

export default Phone;
